import { map } from "rxjs";
import { GET, POST } from "../../../../module/services/fetch";

export const fetchGetRoleNewVisibilityCone = () =>
  GET(`authentication/admin/view-roles`).pipe(map((response: any) => response));

export const fetchAllUsers = (payload: any) => {
  const { callBody, sortBy } = payload;
  return POST(
    `admin/users/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    callBody
  ).pipe(map((response: any) => response));
};

export const fetchUserRoles = (queryParams: string) =>
  GET(`authentication/admin/user/static-roles${queryParams}`).pipe(
    map((response: any) => response)
  );

export const fetchAllSelectableRoles = (queryParams: any) =>
  GET(`authentication/admin/static-roles${queryParams}`).pipe(
    map((response: any) => response)
  );

export const fetchsendModifiedRoles = (body: any) =>
  POST(`authentication/admin/user/static-roles`, body).pipe(
    map((response: any) => response)
  );

export const fetchAllVisibilityCones = () =>
  GET("authentication/admin/visibility-cone").pipe(
    map((response: any) => response)
  );

export const fetchAddOrUpdateRole = (body: any) =>
  POST(`authentication/admin/static-roles`, body).pipe(
    map((response: any) => response)
  );

export const fetchDeleteRole = (body: any) =>
  POST(`authentication/admin/static-roles/delete`, body).pipe(
    map((response: any) => response)
  );

export const fetchAddOrUpdateVisibilityCone = (body: any) =>
  POST(`authentication/admin/visibility-cone`, body).pipe(
    map((response: any) => response)
  );

export const fetchDeleteVisibilityCone = (body: any) =>
  POST(`authentication/admin/visibility-cone/delete`, body).pipe(
    map((response: any) => response)
  );
